import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeMode = 'light' | 'dark';

interface ThemeState {
    mode: ThemeMode;
}

interface ThemeActions {
    toggleTheme: () => void;
    setTheme: (mode: ThemeMode) => void;
}

type ThemeStore = ThemeState & ThemeActions;

/**
 * Theme store with localStorage persistence
 */
export const useThemeStore = create<ThemeStore>()(
    persist(
        (set) => ({
            mode: 'dark',

            toggleTheme: () => {
                set((state) => ({
                    mode: state.mode === 'light' ? 'dark' : 'light',
                }));
            },

            setTheme: (mode: ThemeMode) => {
                set({ mode });
            },
        }),
        {
            name: 'arcanum-theme',
        },
    ),
);

export default useThemeStore;
